// extracted by mini-css-extract-plugin
export default {"deleteModal":"deleteModal__tvLJcf","bold":"bold__CjcmOK"};